import { jsx as t, jsxs as d, Fragment as A } from "react/jsx-runtime";
import { StatusIcon as se, Icon as q, InformationIcon as qe } from "@strata/react-status-icons";
import { PerformanceStatusIndicator as c, StatusIndicator as be } from "@strata/react-status-indicators";
import "./main.scss";
import { IconNames as E } from "@blueprintjs/icons";
import { formatDate as $, DateFormats as ne, formatPercentageString as Ae, conditionalString as Re } from "@strata/helper-functions";
import { ActionButtonText as O } from "@strata/react-buttons";
import { Card as k } from "@strata/react-cards";
import { DollarAmount as je } from "@strata/react-dollar-amount";
import { formatMarkDownLinks as Y } from "@strata/react-hyperlink";
import { DetailLabel as V, DetailLabelValuePair as Q, DetailValue as $e } from "@strata/react-label-value-pairs";
import { CountdownTimer as Ge } from "@strata/react-timers";
import m from "classnames";
import { InlineMessage as F } from "@strata/react-inline-message";
import { Divider as We } from "@blueprintjs/core";
import { InfoDialog as Ye, DialogWithForm as He } from "@strata/react-dialog";
import { DynamicInputFormik as H } from "@strata/react-dynamic-input";
import { useFormikContext as K, getIn as S, FieldArray as Qe, Formik as Ne } from "formik";
import { useState as J, useEffect as Ke, Fragment as ye } from "react";
import * as r from "yup";
import { CheckboxListFormik as Xe } from "@strata/react-checkbox-list";
import { TextAreaFormik as we, NumberInputFormik as le } from "@strata/react-inputs";
import { RadioButtonGroupFormik as B } from "@strata/react-radio-button-group";
import { validationStrings as f } from "@strata/strata-ui-strings";
import { DateInputFormik as oe } from "@strata/react-date-time";
import { SuggestSingleSelectFormik as de } from "@strata/react-selects";
import { ProgressBar as ke } from "@strata/react-progress-bar";
import { FileUploadFormik as Je } from "@strata/react-file-upload";
const Ze = {
  [c.Statuses.SUCCESSFUL]: "Requirement completed successfully.",
  [c.Statuses.UNSUCCESSFUL]: "Requirement completed unsuccessfully."
}, et = {
  [c.Statuses.SUCCESSFUL]: se.Statuses.GOOD,
  [c.Statuses.UNSUCCESSFUL]: se.Statuses.CAUTION
}, tt = ({
  status: e = void 0,
  size: s,
  showEmptyCircle: n = !1,
  className: o
}) => /* @__PURE__ */ t(
  se,
  {
    status: e && et[e],
    size: s,
    tooltipText: e ? Ze[e] : "Requirement not yet completed.",
    title: "Performance Item Status",
    showEmptyCircle: n,
    className: o
  }
), Pe = (e, s, n) => /* @__PURE__ */ t(
  F,
  {
    intent: e === s ? F.Intent.SUCCESS : F.Intent.ERROR,
    label: `${e} of ${s} ${n}`
  }
), ce = (e, s) => {
  let n = F.Intent.INFO;
  return e === c.Statuses.SUCCESSFUL ? n = F.Intent.SUCCESS : e === c.Statuses.UNSUCCESSFUL && (n = F.Intent.ERROR), /* @__PURE__ */ t(F, { intent: n, label: s });
}, Z = {
  MANUAL: "MANUAL",
  AUTOMATIC: "AUTOMATIC"
}, Le = (e) => e == null ? void 0 : e.filter((s) => (s.conditions ?? []).length > 0), st = (e) => e == null ? void 0 : e.filter((s) => (Le(s.subtasks) ?? []).length > 0), ae = (e) => {
  const s = ((e == null ? void 0 : e.conditions) ?? [])[0];
  return e != null && e.subtask_type ? (e == null ? void 0 : e.subtask_type) === Z.MANUAL : (s == null ? void 0 : s.condition_type) === Z.MANUAL;
}, ee = (e) => {
  const s = ((e == null ? void 0 : e.conditions) ?? [])[0];
  return e != null && e.subtask_type ? (e == null ? void 0 : e.subtask_type) === Z.AUTOMATIC : (s == null ? void 0 : s.condition_type) === Z.AUTOMATIC;
}, nt = (e) => e == null ? void 0 : e.some((s) => (s.subtasks ?? []).some(ae)), ot = (e) => e == null ? void 0 : e.some((s) => (s.subtasks ?? []).some(ee)), ie = (e) => {
  const s = structuredClone(e);
  if (s !== null)
    return Array.isArray(s) ? s.forEach((n, o) => {
      s[o] = ie(n);
    }) : typeof s == "object" && Object.keys(s).forEach((n) => {
      s[n] = ie(s[n]);
    }), s;
}, Ie = ({
  completionStatus: e
}) => e == null || e === c.Statuses.NOT_STARTED, Ee = {
  [c.Statuses.SUCCESSFUL]: E.CONFIRM,
  [c.Statuses.UNSUCCESSFUL]: E.ERROR,
  [c.Statuses.PENDING]: E.TIME,
  [c.Statuses.NOT_STARTED]: E.FULL_CIRCLE
}, at = {
  [c.Statuses.SUCCESSFUL]: q.Intent.SUCCESS,
  [c.Statuses.UNSUCCESSFUL]: q.Intent.ERROR,
  [c.Statuses.PENDING]: q.Intent.INFO,
  [c.Statuses.NOT_STARTED]: void 0
}, Ue = {
  [c.Statuses.SUCCESSFUL]: "Completed",
  [c.Statuses.UNSUCCESSFUL]: "Not Completed",
  [c.Statuses.PENDING]: "Waiting on Claim Data",
  [c.Statuses.NOT_STARTED]: "Not Started"
}, it = ({
  status: e = void 0,
  tooltipText: s = void 0,
  size: n = 12,
  showEmptyCircle: o = !1,
  className: i,
  popoverClassName: a
}) => e ?? o ? /* @__PURE__ */ t(
  q,
  {
    icon: (e && Ee[e]) ?? Ee[c.Statuses.NOT_STARTED],
    size: n,
    intent: e && at[e],
    tooltipContent: s ?? (e && Ue[e]) ?? Ue[c.Statuses.NOT_STARTED],
    className: m("sds_status-icon", i),
    popoverClassName: a
  }
) : null, rt = ({
  task: e,
  onAddDocumentationClick: s = void 0,
  onViewClaimClick: n = void 0
}) => {
  var i;
  const o = Le(e.subtasks);
  return /* @__PURE__ */ t(
    k,
    {
      cardStatus: e.task_status,
      cardStatusTooltipMap: {
        [k.Statuses.CAUTION]: "Task is Overdue.",
        [k.Statuses.WARNING]: "Task is Due Soon."
      },
      headerLeftContent: /* @__PURE__ */ d("div", { className: "sds_performance-item__row", children: [
        /* @__PURE__ */ t(
          tt,
          {
            status: e.status,
            showEmptyCircle: !0,
            size: 14,
            className: "padding__right--x-small"
          }
        ),
        /* @__PURE__ */ t("span", { className: "sds_performance-item__header-title", children: e.task_name })
      ] }),
      bodyContent: /* @__PURE__ */ d(A, { children: [
        o == null ? void 0 : o.map((a, _) => {
          const u = a.subtask_id ?? a.distinctId;
          return /* @__PURE__ */ t("div", { children: /* @__PURE__ */ d(
            "div",
            {
              className: m(
                "sds_performance-item__row",
                "sds_performance-item__subtask-row",
                {
                  "padding__bottom--small": ((o == null ? void 0 : o.length) ?? 0) - 1 > _
                }
              ),
              children: [
                /* @__PURE__ */ d("span", { className: "sds_performance-item__row", children: [
                  /* @__PURE__ */ t(
                    it,
                    {
                      status: a.completion_status,
                      showEmptyCircle: !0,
                      size: 12,
                      className: "padding__right--x-small"
                    }
                  ),
                  /* @__PURE__ */ t(
                    "span",
                    {
                      className: m(
                        "font-semi-bold--capitalize",
                        "padding__top--small",
                        "padding__right--small",
                        "padding__bottom--small",
                        "sds_performance-item__subtask-text"
                      ),
                      children: a.subtask_title
                    }
                  ),
                  ae(a) && /* @__PURE__ */ d(
                    "span",
                    {
                      className: m(
                        "font-regular--italic",
                        "sds_performance-item__subtask-text",
                        "sds_performance-item__subtask-text--subtext"
                      ),
                      children: [
                        "Due: ",
                        $(a.due_date) ?? "--"
                      ]
                    }
                  ),
                  ee(a) && /* @__PURE__ */ d(
                    "span",
                    {
                      className: m(
                        "font-regular--italic",
                        "sds_performance-item__subtask-text",
                        "sds_performance-item__subtask-text--subtext"
                      ),
                      children: [
                        "Date of Service:",
                        " ",
                        $(a.service_date) ?? "--"
                      ]
                    }
                  )
                ] }),
                ae(a) && /* @__PURE__ */ t(
                  O,
                  {
                    label: Ie({
                      completionStatus: a.completion_status
                    }) ? "Add Documentation" : "View/Edit Documentation",
                    leftIcon: Ie({
                      completionStatus: a.completion_status
                    }) ? E.ADD : void 0,
                    disabled: !s,
                    onClick: () => s == null ? void 0 : s(u)
                  }
                ),
                ee(a) && /* @__PURE__ */ t(
                  O,
                  {
                    label: "View Claim",
                    disabled: !n,
                    onClick: () => n == null ? void 0 : n(u)
                  }
                )
              ]
            }
          ) }, u);
        }),
        (i = e.banners) == null ? void 0 : i.map((a) => /* @__PURE__ */ t(
          "div",
          {
            className: m(
              "padding__top--medium",
              "padding__right--small",
              "padding__bottom--small"
            ),
            children: Number.isInteger(a.events_found) && Number.isInteger(a.events_expected) ? Pe(
              a.events_found,
              a.events_expected,
              a.message
            ) : ce(a.status, a.message)
          },
          a.message
        ))
      ] })
    }
  );
}, lt = (e) => {
  const s = e.length;
  return s < 1 ? "" : `(${e.filter(
    (o) => o.status === c.Statuses.SUCCESSFUL
  ).length} of ${s} Completed)`;
}, dt = (e) => e ? /* @__PURE__ */ t(Ge, { endTime: e }) : /* @__PURE__ */ t(be, { status: be.Status.DEFAULT, message: "--" }), Xt = ({
  performanceRequirementId: e = void 0,
  performanceStatus: s = void 0,
  incentiveAmount: n,
  performanceName: o,
  performanceDescription: i,
  performanceDueDate: a = void 0,
  performanceEvaluationDate: _ = void 0,
  banners: u = void 0,
  onAddDocumentationClick: v,
  tasksData: C = void 0,
  onReportSetbackClick: g = void 0,
  onViewClaimClick: T
}) => {
  const M = nt(C), R = ot(C), h = st(C);
  return /* @__PURE__ */ t(
    k,
    {
      className: "sds_performance-item",
      overlay: s === c.Statuses.VOIDED ? {
        icon: E.TIME,
        primaryText: "Performance Requirement Voided.",
        secondaryText: "This referral was not serviced for the minimum days required. It won't be evaluated successful or unsuccessful. Any service incentive or tasks are no longer relevant"
      } : void 0,
      headerLeftContent: /* @__PURE__ */ d("div", { className: "sds_performance-item__row", children: [
        /* @__PURE__ */ t("div", { className: "sds_performance-item__header-title", children: o }),
        /* @__PURE__ */ t(
          "div",
          {
            className: m(
              "sds_performance-item__header-incentive",
              "margin__left--small"
            ),
            children: n > 0 && /* @__PURE__ */ t(je, { amount: n, hideCents: !0, large: !0 })
          }
        )
      ] }),
      headerRightContent: /* @__PURE__ */ d("span", { className: "sds_performance-item__row", children: [
        M && /* @__PURE__ */ t(
          q,
          {
            icon: E.MANUALLY_ENTERED_DATA,
            size: 12,
            className: m("sds_performance-item__header-activation-type", {
              "margin__right--small": R,
              "margin__right--medium": !R
            }),
            tooltipContent: "Includes manually updated tasks."
          }
        ),
        R && /* @__PURE__ */ t(
          q,
          {
            icon: E.AUTOMATIC_UPDATES,
            size: 12,
            className: m(
              "sds_performance-item__header-activation-type",
              "margin__right--medium"
            ),
            tooltipContent: "Includes system updated tasks."
          }
        ),
        s && /* @__PURE__ */ t(c, { status: s })
      ] }),
      bodyContent: /* @__PURE__ */ d(A, { children: [
        /* @__PURE__ */ t(
          "div",
          {
            className: m(
              "sds_performance-item__header-description",
              "padding__bottom--large"
            ),
            children: Y(i)
          }
        ),
        /* @__PURE__ */ d(
          "div",
          {
            className: m(
              "sds_performance-item__date-section",
              "padding__bottom--large"
            ),
            children: [
              /* @__PURE__ */ d("div", { children: [
                /* @__PURE__ */ t(V, { label: "Due In" }),
                dt(a)
              ] }),
              a && _ && /* @__PURE__ */ d(A, { children: [
                /* @__PURE__ */ d(
                  "div",
                  {
                    className: m(
                      "padding__left--x-large",
                      "sds_performance-item__column"
                    ),
                    children: [
                      /* @__PURE__ */ t(V, { label: "Due Date" }),
                      /* @__PURE__ */ t("div", { className: "sds_performance-item__date-section--text", children: $(a) || "--" })
                    ]
                  }
                ),
                /* @__PURE__ */ d(
                  "div",
                  {
                    className: m(
                      "padding__left--x-large",
                      "sds_performance-item__column"
                    ),
                    children: [
                      /* @__PURE__ */ t(V, { label: "Evaluated On" }),
                      /* @__PURE__ */ d(
                        "div",
                        {
                          className: m(
                            "sds_performance-item__row",
                            "sds_performance-item__date-section--text-with-info"
                          ),
                          children: [
                            $(_) || "--",
                            /* @__PURE__ */ t(
                              qe,
                              {
                                size: 14,
                                className: m(
                                  "sds_performance-item__date-section--info",
                                  "padding__left--small"
                                ),
                                tooltipText: "Evaluated on is the date when successful/unsuccessful evaluation will happen."
                              }
                            )
                          ]
                        }
                      )
                    ]
                  }
                )
              ] })
            ]
          }
        ),
        u == null ? void 0 : u.map((y) => /* @__PURE__ */ t("div", { className: "padding__bottom--small", children: Number.isInteger(y.events_found) && Number.isInteger(y.events_expected) ? Pe(
          y.events_found,
          y.events_expected,
          y.message
        ) : ce(y.status, y.message) }, y.message))
      ] }),
      footerContent: h && h.length > 0 && /* @__PURE__ */ d("div", { children: [
        /* @__PURE__ */ d(
          "div",
          {
            className: m(
              "sds_performance-item__row",
              "sds_performance-item__footer-header",
              "padding__left--medium"
            ),
            children: [
              /* @__PURE__ */ d("span", { className: "sds_performance-item__row__left-content", children: [
                /* @__PURE__ */ t("span", { children: /* @__PURE__ */ t(V, { label: "Requirement(s)" }) }),
                /* @__PURE__ */ t(
                  "span",
                  {
                    className: m(
                      "sds_performance-item__footer-header__tasks-completed-message",
                      "padding__left--small"
                    ),
                    children: /* @__PURE__ */ t(V, { label: lt(h) })
                  }
                )
              ] }),
              g && /* @__PURE__ */ t(
                O,
                {
                  leftIcon: E.ADD,
                  label: "Report Setback",
                  onClick: () => g(e),
                  className: m(
                    "sds_performance-item__row__right-content",
                    "margin__right--medium",
                    "padding__top--x-small",
                    "padding__bottom--x-small"
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            className: m(
              "padding__around--medium",
              "sds_performance-item__column",
              "sds_performance-item__footer-column"
            ),
            children: h.map((y) => /* @__PURE__ */ t(
              rt,
              {
                task: y,
                onAddDocumentationClick: v,
                onViewClaimClick: T
              },
              y.task_id ?? y.distinctId
            ))
          }
        )
      ] })
    }
  );
}, Fe = {
  [c.Statuses.SUCCESSFUL]: {
    intent: q.Intent.SUCCESS,
    icon: E.TICK
  },
  [c.Statuses.UNSUCCESSFUL]: {
    intent: q.Intent.ERROR,
    icon: E.ERROR
  }
}, me = ({
  status: e = void 0,
  value: s = void 0,
  message: n = void 0,
  inline: o = !1
}) => {
  var i, a;
  return s == null ? /* @__PURE__ */ t("span", { children: "--" }) : /* @__PURE__ */ d(
    "span",
    {
      className: m(
        "sds_performance-subtask-dialog__row",
        "sds_performance-subtask-dialog__row--justify-left"
      ),
      style: { float: o ? "left" : "inherit" },
      children: [
        /* @__PURE__ */ t(
          "span",
          {
            className: m("padding__right--small", {
              [`sds_performance-subtask-dialog__condition__status--${e}`]: e && s
            }),
            children: s
          }
        ),
        e && /* @__PURE__ */ t(
          q,
          {
            icon: (i = Fe[e]) == null ? void 0 : i.icon,
            size: 14,
            intent: (a = Fe[e]) == null ? void 0 : a.intent,
            className: "padding__right--small"
          }
        ),
        n
      ]
    }
  );
}, ct = [
  { text: "No visible blood (0)", value: "0" },
  { text: "Visible blood with stool less than half the time (+1)", value: "1" },
  { text: "Visible blood with stool more than half the time (+2)", value: "2" },
  { text: "Passing blood alone (+3)", value: "3" }
], mt = [
  { text: "Normal (0)", value: "0" },
  { text: "1-2 more than usual (+1)", value: "1" },
  { text: "3-4 more than usual (+2)", value: "2" },
  { text: "5 or more than usual (+3)", value: "3" }
], _t = (e) => {
  let s = !1;
  const n = e.map((o) => {
    const i = o ? parseInt(o, 10) : NaN;
    return Number.isNaN(i) ? (s = !0, 0) : i;
  });
  if (!s)
    return n.reduce((o, i) => o + i, 0);
}, ut = ({
  values: e,
  addends: s,
  id: n
}) => {
  const o = (S(e, `${n}.intervention`) ?? []).includes(
    "Other"
  ), i = _t(s);
  return { showOtherTextArea: o, score: i };
}, _e = ({
  id: e,
  status: s,
  messaging: n = "This is an automatic update based off of scores above.",
  disableInitial: o = !1,
  disabled: i = !1,
  showInterventionsChecklist: a = !1
}) => {
  const _ = K(), [u, v] = J(!1), C = [
    S(_.values, `${e}.rectal_bleeds`),
    S(_.values, `${e}.stool_frequency`)
  ], { showOtherTextArea: g, score: T } = ut({ values: _.values, addends: C, id: e });
  return /* @__PURE__ */ d(A, { children: [
    /* @__PURE__ */ t(
      B,
      {
        name: `${e}.rectal_bleeds`,
        label: "Rectal Bleeds",
        options: ct,
        disabled: o || i,
        required: !0,
        onChange: (M) => {
          (async () => (v(!0), await _.setFieldValue(`${e}.rectal_bleeds`, M)))();
        }
      }
    ),
    /* @__PURE__ */ t(
      B,
      {
        name: `${e}.stool_frequency`,
        label: "Stool Frequency",
        options: mt,
        disabled: o || i,
        required: !0,
        onChange: (M) => {
          (async () => (v(!0), await _.setFieldValue(`${e}.stool_frequency`, M)))();
        }
      }
    ),
    /* @__PURE__ */ t(
      Q,
      {
        label: "Disease State Score (Total From Rectal Bleeds + Stool Frequency)",
        value: /* @__PURE__ */ d("div", { children: [
          /* @__PURE__ */ t(
            me,
            {
              value: T,
              status: u ? void 0 : s,
              inline: !u && (n == null ? void 0 : n.length) > 1
            }
          ),
          !u && /* @__PURE__ */ t("span", { children: T !== void 0 && (n == null ? void 0 : n.length) > 1 && ` (${n})` })
        ] }),
        className: m("padding__bottom--small", "padding__top--small", {
          "padding__bottom--medium": a
        })
      }
    ),
    a && /* @__PURE__ */ d(A, { children: [
      /* @__PURE__ */ t("div", { className: m({ "padding__bottom--medium": g }), children: /* @__PURE__ */ t(
        Xe,
        {
          name: `${e}.intervention`,
          options: [
            "Adherence counseling",
            "Nutrition education",
            "Therapy change",
            "Dose change",
            "Adverse effects counseling",
            "Disease education",
            "Connecting with Case Management",
            "Other"
          ],
          label: "Intervention for Worsening Disease",
          disabled: i,
          required: !0
        }
      ) }),
      g && /* @__PURE__ */ t(
        we,
        {
          id: `${e}.intervention_description`,
          label: "Intervention Description",
          disabled: i,
          required: !0
        }
      )
    ] })
  ] });
};
_e.type = "additive_score";
_e.validationSchema = ({ showInterventionsChecklist: e }) => r.object({
  rectal_bleeds: r.string().required(f.requiredField.errorMessage),
  stool_frequency: r.string().required(f.requiredField.errorMessage),
  intervention: e ? r.array(r.string()).min(1, f.requiredField.errorMessage).required(f.requiredField.errorMessage) : r.array(r.string()),
  intervention_description: r.string().when("intervention", {
    is: (s) => {
      var n;
      return (n = s == null ? void 0 : s[0]) == null ? void 0 : n.includes("Other");
    },
    then: (s) => s.required(f.requiredField.errorMessage)
  })
});
const ue = ({
  id: e,
  sinceDate: s = void 0,
  sinceDateName: n = void 0,
  disabled: o = !1
}) => {
  const i = K(), a = S(i.values, `${e}.any_bleeding`) === "yes", _ = S(i.values, `${e}.bleeding_events`), u = a && ((_ == null ? void 0 : _.length) ?? 0) < 1;
  Ke(() => {
    (async () => u && await i.setFieldValue(`${e}.bleeding_events`, [{}]))();
  }, [i, e, u]);
  const v = n ? `${n} Date` : "Last Fill Date", C = (n == null ? void 0 : n.toLowerCase()) ?? "last fill";
  return /* @__PURE__ */ d(A, { children: [
    /* @__PURE__ */ t(
      Q,
      {
        label: v,
        value: $(s),
        className: "sds_performance-subtask-dialog__claim-detail padding__bottom--small"
      }
    ),
    /* @__PURE__ */ t("div", { className: m({ "padding__bottom--small": a }), children: /* @__PURE__ */ t(
      B,
      {
        options: [
          { text: "Yes", value: "yes" },
          { text: "No", value: "no" }
        ],
        label: `Any bleeding history since ${C}?`,
        name: `${e}.any_bleeding`,
        required: !0,
        onChange: (g) => {
          (async () => (await i.setFieldValue(`${e}.any_bleeding`, g), g === "yes" ? await i.setFieldValue(`${e}.bleeding_events`, [{}]) : g === "no" && await i.setFieldValue(`${e}.bleeding_events`, [])))();
        },
        disabled: o
      }
    ) }),
    a && /* @__PURE__ */ t(Qe, { name: `${e}.bleeding_events`, children: (g) => {
      const T = (_ == null ? void 0 : _.length) ?? 0, M = T > 1;
      return /* @__PURE__ */ d(A, { children: [
        (_ ?? []).map((R, h) => /* @__PURE__ */ d(
          "span",
          {
            className: m("sds_performance-item__row", {
              "padding__bottom--small": T - 1 > h
            }),
            style: { justifyItems: "space-between" },
            children: [
              /* @__PURE__ */ d(
                "div",
                {
                  className: m(
                    "sds_performance-item__row__left-content",
                    "padding__bottom--medium",
                    {
                      "padding__right--medium": M
                    }
                  ),
                  children: [
                    /* @__PURE__ */ t("div", { className: "padding__bottom--medium", children: /* @__PURE__ */ t(
                      oe,
                      {
                        id: `${g.name}.${h}.bleeding_event_date`,
                        label: `Date of Bleeding Event ${h + 1}`,
                        requiredValidationMessage: S(
                          i.errors,
                          `${g.name}.${h}.bleeding_event_date`
                        ) && S(
                          i.touched,
                          `${g.name}.${h}.bleeding_event_date`
                        ) ? f.requiredField.errorMessage : null,
                        onChange: (y) => {
                          i.setFieldValue(
                            `${g.name}.${h}.bleeding_event_date`,
                            $(
                              y,
                              ne.HYPHEN_DATE
                            )
                          );
                        },
                        value: S(
                          i.values,
                          `${g.name}.${h}.bleeding_event_date`
                        ),
                        required: !0,
                        disabled: o
                      }
                    ) }),
                    /* @__PURE__ */ t(
                      we,
                      {
                        id: `${g.name}.${h}.bleeding_event_description`,
                        label: `Description of Bleeding Event ${h + 1}`,
                        required: !0,
                        disabled: o
                      }
                    )
                  ]
                }
              ),
              M && /* @__PURE__ */ t(
                q,
                {
                  icon: E.CROSS,
                  onClick: () => {
                    g.remove(h);
                  },
                  title: "Remove",
                  className: m(
                    "sds_performance-item__row__right-content",
                    "sds_performance-subtask-dialog__button"
                  )
                }
              )
            ]
          },
          h
        )),
        /* @__PURE__ */ t(
          O,
          {
            label: "Add another bleeding event",
            leftIcon: E.ADD,
            onClick: () => g.push(void 0)
          }
        )
      ] });
    } })
  ] });
};
ue.type = "bleeding_history";
ue.validationSchema = r.object({
  any_bleeding: r.string().required(f.requiredField.errorMessage),
  bleeding_events: r.array(
    r.object({
      bleeding_event_date: r.date().required(f.requiredField.errorMessage),
      bleeding_event_description: r.string().required(
        f.requiredField.errorMessage
      )
    })
  )
});
const pt = "Claim was reversed.", L = {
  CLAIM_DATE_OF_SERVICE: "Claim Date Of Service",
  CLAIM_NUMBER: "Claim Number",
  DAYS_SUPPLY: "Days Supply",
  RX_NUMBER: "Rx Number",
  DISPENSING_NPI: "Dispensing NPI",
  NDC: "NDC"
}, re = {
  [L.CLAIM_DATE_OF_SERVICE]: {
    style: { minWidth: 125 },
    value: ({ service_start_date: e }) => $(e)
  },
  [L.CLAIM_NUMBER]: {
    style: { minWidth: 85 },
    value: ({ claim_id: e }) => e
  },
  [L.DAYS_SUPPLY]: {
    style: { minWidth: 85 },
    value: ({ drug_days_supply: e }) => e
  },
  [L.RX_NUMBER]: {
    style: { minWidth: 85 },
    value: ({ prescription_number: e }) => e
  },
  [L.DISPENSING_NPI]: {
    style: { minWidth: 125 },
    value: ({ pharmacy_npi: e }) => e
  },
  [L.NDC]: {
    style: { minWidth: 125 },
    value: ({ product_ndc: e }) => e
  }
}, Te = (e, s) => /* @__PURE__ */ t("div", { className: "sds_performance-subtask-dialog__row", children: (e ?? [L.CLAIM_DATE_OF_SERVICE]).map((n) => {
  var o, i, a;
  return /* @__PURE__ */ t(
    "div",
    {
      className: "sds_performance-subtask-dialog__claim-detail padding__top--small",
      style: (o = re[n]) == null ? void 0 : o.style,
      children: /* @__PURE__ */ t($e, { value: s ? (a = (i = re[n]) == null ? void 0 : i.value) == null ? void 0 : a.call(i, s) : void 0 })
    },
    n
  );
}) }), De = ({ detailsToShow: e = void 0, claims: s = [] }) => /* @__PURE__ */ d("div", { children: [
  /* @__PURE__ */ t("div", { className: "sds_performance-subtask-dialog__row", children: (e ?? [L.CLAIM_DATE_OF_SERVICE]).map((n) => {
    var o;
    return /* @__PURE__ */ t("div", { style: (o = re[n]) == null ? void 0 : o.style, children: /* @__PURE__ */ t(V, { label: n }) }, n);
  }) }),
  s == null ? void 0 : s.map((n) => /* @__PURE__ */ d(
    "div",
    {
      className: "sds_performance-subtask-dialog__row-container padding__bottom--small",
      children: [
        Te(e, n),
        n.is_reversed && /* @__PURE__ */ t(
          "div",
          {
            className: m(
              "padding__top--small",
              "padding__right--small",
              "padding__bottom--x-small"
            ),
            children: ce(
              c.Statuses.UNSUCCESSFUL,
              pt
            )
          }
        )
      ]
    },
    n.claim_id
  )),
  s.length === 0 && Te(e)
] });
De.type = "claim";
const xe = ({
  claim_date_of_service: e = void 0,
  message: s = void 0
}) => {
  const n = "Patient must receive prescription before the date entered above, this will be validated automatically based on claims data.", o = !e && !s;
  return /* @__PURE__ */ t(
    Q,
    {
      label: "Claim Date of Service Validation",
      value: /* @__PURE__ */ d("div", { className: "font-regular", children: [
        e && /* @__PURE__ */ t("div", { children: $(e) }),
        s && /* @__PURE__ */ t("div", { children: s }),
        o && /* @__PURE__ */ t("div", { children: n })
      ] })
    }
  );
};
xe.type = "claim_dos_validation";
const gt = (e, s) => {
  let n = F.Intent.INFO;
  return e === c.Statuses.SUCCESSFUL ? n = F.Intent.SUCCESS : e === c.Statuses.UNSUCCESSFUL && (n = F.Intent.ERROR), /* @__PURE__ */ t(F, { intent: n, label: s, wrapText: !0 });
}, Oe = ({
  id: e,
  status: s,
  messaging: n = void 0,
  calculatedPartialQuantity: o = void 0,
  disableInitial: i = !1,
  disabled: a = !1,
  prescriberReasons: _ = []
}) => {
  const u = K(), v = s === c.Statuses.UNSUCCESSFUL;
  return /* @__PURE__ */ d(A, { children: [
    /* @__PURE__ */ t("div", { className: "padding__bottom--medium", children: /* @__PURE__ */ t(
      le,
      {
        label: "Patient Weight (kg)",
        id: `${e}.patient_weight`,
        disabled: i || a,
        required: !0
      }
    ) }),
    /* @__PURE__ */ t("div", { className: "padding__bottom--medium", children: /* @__PURE__ */ t(
      oe,
      {
        label: "Date Weight Obtained",
        id: `${e}.date_weight_obtained`,
        requiredValidationMessage: S(u.errors, `${e}.date_weight_obtained`) && S(u.touched, `${e}.date_weight_obtained`) ? f.requiredField.errorMessage : null,
        onChange: (C) => {
          u.setFieldValue(
            `${e}.date_weight_obtained`,
            $(C, ne.HYPHEN_DATE)
          );
        },
        value: S(u.values, `${e}.date_weight_obtained`),
        disabled: i || a,
        required: !0
      }
    ) }),
    s && n && /* @__PURE__ */ t("div", { className: "padding__bottom--medium", children: gt(s, n) }),
    /* @__PURE__ */ t(
      Q,
      {
        label: /* @__PURE__ */ d("div", { style: { display: "flex", alignItems: "center", justifyContent: "left" }, children: [
          /* @__PURE__ */ t("span", { children: "Calculated Partial Quantity" }),
          /* @__PURE__ */ t(
            qe,
            {
              size: 14,
              className: m("padding__left--small"),
              tooltipText: "This value is the dispensed partial package size that will be needed to fulfill the expected administered dose."
            }
          )
        ] }),
        value: /* @__PURE__ */ t(
          me,
          {
            value: Ae(o),
            status: s
          }
        ),
        className: m("padding__bottom--medium", {
          "padding__bottom--large": v
        })
      }
    ),
    v && /* @__PURE__ */ d(A, { children: [
      /* @__PURE__ */ t("div", { className: "padding__bottom--medium", children: /* @__PURE__ */ t(
        de,
        {
          label: "Prescriber Reason",
          id: `${e}.prescriber_reason`,
          disabled: a,
          values: _
        }
      ) }),
      /* @__PURE__ */ t(
        oe,
        {
          label: "Date Contacted",
          id: `${e}.date_contacted`,
          requiredValidationMessage: S(u.errors, `${e}.date_contacted`) && S(u.touched, `${e}.date_contacted`) ? f.requiredField.errorMessage : null,
          onChange: (C) => {
            u.setFieldValue(
              `${e}.date_contacted`,
              $(C, ne.HYPHEN_DATE)
            );
          },
          disabled: a,
          value: S(u.values, `${e}.date_contacted`)
        }
      )
    ] })
  ] });
}, pe = ({
  id: e,
  status: s,
  messaging: n,
  calculatedPartialQuantity: o,
  disableInitial: i = !1,
  disabled: a = !1,
  prescriberReasons: _ = []
}) => /* @__PURE__ */ t(
  Oe,
  {
    id: e,
    status: s,
    messaging: n,
    calculatedPartialQuantity: o,
    disableInitial: i,
    disabled: a,
    prescriberReasons: _
  }
);
pe.type = "dose_management";
pe.validationSchema = r.object({
  patient_weight: r.number().moreThan(0, "Must be greater than zero.").required(f.requiredField.errorMessage),
  date_weight_obtained: r.date().required(f.requiredField.errorMessage),
  prescriber_reason: r.string(),
  date_contacted: r.date()
});
const ge = ({
  id: e,
  status: s,
  messaging: n,
  calculatedPartialQuantity: o,
  disableInitial: i = !1,
  disabled: a = !1,
  prescriberReasons: _ = []
}) => /* @__PURE__ */ d(A, { children: [
  /* @__PURE__ */ t("div", { className: "padding__bottom--medium", children: /* @__PURE__ */ t(
    le,
    {
      label: "Prescribed Dose (MG/KG)",
      id: `${e}.prescribed_dose`,
      disabled: i || a,
      required: !0
    }
  ) }),
  /* @__PURE__ */ t(
    Oe,
    {
      id: e,
      status: s,
      messaging: n,
      calculatedPartialQuantity: o,
      disableInitial: i,
      disabled: a,
      prescriberReasons: _
    }
  )
] });
ge.type = "dose_management_prescribed_dose";
ge.validationSchema = r.object({
  prescribed_dose: r.number().moreThan(0, "Must be greater than zero.").required(f.requiredField.errorMessage),
  patient_weight: r.number().moreThan(0, "Must be greater than zero.").required(f.requiredField.errorMessage),
  date_weight_obtained: r.date().required(f.requiredField.errorMessage),
  prescriber_reason: r.string(),
  date_contacted: r.date()
});
const ht = (e, s) => {
  let n = F.Intent.INFO;
  return e === c.Statuses.SUCCESSFUL ? n = F.Intent.SUCCESS : e === c.Statuses.UNSUCCESSFUL && (n = F.Intent.ERROR), /* @__PURE__ */ t(F, { intent: n, label: s, wrapText: !0 });
}, he = ({
  id: e,
  status: s,
  messaging: n = void 0,
  assayDifferential: o = void 0,
  prescribedDoseUnits: i = void 0,
  disableInitial: a = !1,
  disabled: _ = !1,
  outcomes: u = []
}) => {
  const v = s === c.Statuses.UNSUCCESSFUL;
  return /* @__PURE__ */ d(A, { children: [
    /* @__PURE__ */ t("div", { className: "padding__bottom--medium", children: /* @__PURE__ */ t(
      le,
      {
        label: `Prescribed Dose${Re(
          !!i,
          ` (${i})`
        )}`,
        id: `${e}.prescribed_dose`,
        disabled: a || _,
        required: !0
      }
    ) }),
    s && n && /* @__PURE__ */ t("div", { className: "padding__bottom--medium", children: ht(s, n) }),
    /* @__PURE__ */ t(
      Q,
      {
        label: "Assay Differential",
        value: /* @__PURE__ */ t(
          me,
          {
            value: Ae(o),
            status: s
          }
        ),
        className: m({
          "padding__bottom--large": v
        })
      }
    ),
    s === c.Statuses.UNSUCCESSFUL && /* @__PURE__ */ t(
      de,
      {
        label: "Outcome",
        id: `${e}.outcome`,
        values: u,
        disabled: _,
        required: !0
      }
    )
  ] });
};
he.type = "dose_optimization";
he.validationSchema = ({ status: e }) => r.object({
  prescribed_dose: r.number().moreThan(0).required(f.requiredField.errorMessage),
  outcome: e === c.Statuses.UNSUCCESSFUL ? r.string().required(f.requiredField.errorMessage) : r.string().nullable()
});
const Ve = ({
  supplier_name: e = void 0,
  supplier_npi: s = void 0,
  last_fill_date: n = void 0,
  drug_days_supply: o = void 0
}) => {
  const i = e && s && n;
  return /* @__PURE__ */ d(A, { children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: m(
          "font-regular",
          "sds_performance-subtask-dialog__last-filled-label",
          {
            "padding__bottom--small": i
          }
        ),
        children: i ? "This patient most recently had this medication filled at:" : "Previous pharmacy and claim information is not available."
      }
    ),
    i && /* @__PURE__ */ t(
      $e,
      {
        value: `${e} (NPI: ${s}) on ${$(
          n
        )}${Re(!!o, ` for ${o} day supply`)}`
      }
    )
  ] });
};
Ve.type = "last_filled";
const ft = r.object({
  responses: r.array(
    r.object({
      component_type: r.string(),
      question_id: r.number(),
      question_text: r.string(),
      response_text: r.mixed().when(
        "component_type",
        ([e]) => e === H.defaultFieldTypes.CHECKBOX_LIST ? r.array(r.string()) : r.string()
      ),
      response_id: r.mixed().when(
        "component_type",
        ([e]) => e === H.defaultFieldTypes.CHECKBOX_LIST ? r.array().of(r.number()).min(1, f.requiredField.errorMessage).required(f.requiredField.errorMessage) : r.number().required(f.requiredField.errorMessage)
      )
    })
  )
}), St = (e) => ({
  text: e.response_text,
  value: String(e.response_id),
  ...e
}), fe = ({
  id: e,
  disabled: s = !1,
  questions: n = []
}) => {
  const o = K(), [i, a] = J(0), _ = n[0], u = n[1], v = n.slice(2), C = `${e}.responses`, g = (l) => `${C}.${l}`, T = (l, p) => {
    const N = g(p);
    return {
      name: `${N}.response_id`,
      options: l.response_options.map(St),
      responseTextMap: l.response_options.reduce(
        (U, I) => ({
          ...U,
          [String(I.response_id)]: I.response_text
        }),
        {}
      ),
      objectPath: N,
      responseBody: {
        component_type: l.component_type,
        question_id: l.question_id,
        question_text: l.question_text
      }
    };
  }, M = (S(o.errors, C) ?? []).filter((l) => (l == null ? void 0 : l.response_id) != null), R = T(_, 0), h = T(u, 1), y = (l = [S(o.values, R.objectPath)]) => {
    var p;
    return ((p = l[0]) == null ? void 0 : p.response_id) === "1";
  }, z = (l = [
    S(o.values, R.objectPath),
    S(o.values, h.objectPath)
  ]) => {
    var p;
    return y(l) && ((p = l[1]) == null ? void 0 : p.response_id) === "1";
  }, P = async (l) => {
    const p = (S(o.values, C) ?? []).slice(2).length > 0;
    z(l) && !p ? await o.setFieldValue(C, [
      ...l,
      ...[...Array(n.length - 2).keys()].map(() => ({}))
    ]) : y(l) ? await o.setFieldValue(C, l) : await o.setFieldValue(C, [l[0]]);
  }, j = v.length, G = j - M.length, X = Math.round(G / j * 100), b = [
    /* @__PURE__ */ d(ye, { children: [
      /* @__PURE__ */ t("div", { className: "sds_performance-subtask-dialog__sdoh-condition__consent", children: _.question_text }),
      /* @__PURE__ */ t(
        B,
        {
          name: R.name,
          label: "",
          options: R.options,
          disabled: s,
          required: !0,
          onChange: (l) => {
            P([
              {
                ...R.responseBody,
                response_id: l,
                response_text: R.responseTextMap[l]
              },
              S(o.values, g(1)) ?? {}
            ]);
          }
        }
      ),
      y() && /* @__PURE__ */ t(
        B,
        {
          name: h.name,
          label: u.question_text,
          options: h.options,
          disabled: s,
          required: !0,
          onChange: (l) => {
            P([
              S(o.values, g(0)) ?? {},
              {
                ...h.responseBody,
                response_id: l,
                response_text: h.responseTextMap[l]
              }
            ]);
          }
        }
      ),
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "right"
          },
          children: /* @__PURE__ */ t(
            O,
            {
              label: "Start Survey",
              rightIcon: E.CHEVRON_RIGHT,
              disabled: !z(),
              onClick: () => a(1)
            }
          )
        }
      )
    ] }, "consent"),
    ...v.map((l, p) => {
      const N = T(l, p + 2), U = !S(o.errors, N.name);
      return /* @__PURE__ */ d(ye, { children: [
        /* @__PURE__ */ d("div", { className: "sds_performance-subtask-dialog__sdoh-condition__progress-values", children: [
          /* @__PURE__ */ t("span", { children: `${G}/${j} questions complete` }),
          /* @__PURE__ */ t("span", { children: `${X}%` })
        ] }),
        /* @__PURE__ */ t(
          ke,
          {
            total: v.length,
            completed: v.length - M.length
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            className: m("padding__top--medium", "padding__bottom--medium"),
            children: /* @__PURE__ */ t(
              H,
              {
                id: N.name,
                component: {
                  type: l.component_type,
                  label: l.question_text,
                  required: !0,
                  options: N.options,
                  disabled: s
                },
                onChange: (I) => {
                  o.setFieldValue(N.objectPath, {
                    ...N.responseBody,
                    response_id: I,
                    response_text: Array.isArray(I) ? I.map(
                      (D) => N.responseTextMap[D]
                    ) : N.responseTextMap[I]
                  });
                }
              }
            )
          },
          N.name
        ),
        /* @__PURE__ */ d(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between"
            },
            children: [
              /* @__PURE__ */ t(
                O,
                {
                  label: "Previous",
                  leftIcon: E.CHEVRON_LEFT,
                  onClick: () => a((I) => I - 1)
                }
              ),
              v.length > p + 1 && /* @__PURE__ */ t(
                O,
                {
                  label: "Next",
                  rightIcon: E.CHEVRON_RIGHT,
                  disabled: !U,
                  onClick: () => a((I) => I + 1)
                }
              )
            ]
          }
        )
      ] }, N.name);
    })
  ];
  return /* @__PURE__ */ t("div", { className: "sds_performance-subtask-dialog__sdoh-condition", children: b[i] });
};
fe.type = "sdoh_barrier_assessment";
fe.validationSchema = ft;
const Se = ({
  id: e,
  questionLabel: s = "",
  uploadLabel: n = "",
  reasonLabel: o = "",
  reasons: i = [],
  onAddFiles: a,
  disabled: _ = !1
}) => {
  const u = K(), v = `${e}.upload_else_reason`, C = S(u.values, v) === "yes", g = S(u.values, v) === "no";
  return /* @__PURE__ */ d(A, { children: [
    /* @__PURE__ */ t(
      B,
      {
        options: [
          { text: "Yes", value: "yes" },
          { text: "No", value: "no" }
        ],
        label: Y(s),
        name: v,
        required: !0,
        disabled: _
      }
    ),
    C && /* @__PURE__ */ t(
      Je,
      {
        id: `${e}.uer_upload`,
        label: Y(n),
        verticalSpacingSmall: !0,
        required: !0,
        onAddFiles: a,
        disabled: _
      }
    ),
    g && /* @__PURE__ */ t(
      de,
      {
        id: `${e}.uer_reason`,
        label: Y(o),
        values: i,
        verticalSpacingSmall: !0,
        required: !0,
        disabled: _
      }
    )
  ] });
};
Se.type = "upload_else_reason";
Se.validationSchema = r.object({
  upload_else_reason: r.string().required(f.requiredField.errorMessage),
  uer_upload: r.array().of(
    r.object({
      isUploading: r.bool(),
      name: r.string(),
      size: r.number()
    })
  ).when("upload_else_reason", {
    is: "yes",
    then: (e) => e.required(f.requiredField.errorMessage).min(1, f.requiredField.errorMessage)
  }),
  uer_reason: r.string().when("upload_else_reason", {
    is: "no",
    then: (e) => e.required(f.requiredField.errorMessage)
  })
});
const vt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AdditiveScore: _e,
  BleedingHistory: ue,
  Claim: De,
  ClaimDateOfServiceValidation: xe,
  DoseManagement: pe,
  DoseManagementWithPrescribedDose: ge,
  DoseOptimization: he,
  LastFilled: Ve,
  SDoHBarrierAssessment: fe,
  UploadElseReason: Se
}, Symbol.toStringTag, { value: "Module" })), Ct = {
  [c.Statuses.SUCCESSFUL]: E.TICK_CIRCLE,
  [c.Statuses.PENDING]: E.TIME,
  [c.Statuses.UNSUCCESSFUL]: E.ERROR
}, bt = {
  [c.Statuses.SUCCESSFUL]: q.Intent.SUCCESS,
  [c.Statuses.PENDING]: q.Intent.INFO,
  [c.Statuses.UNSUCCESSFUL]: q.Intent.ERROR
}, Me = ({
  status: e = void 0,
  tooltipText: s = void 0,
  size: n = 12,
  showEmptyCircle: o = !1,
  className: i,
  popoverClassName: a
}) => e ?? o ? /* @__PURE__ */ t(
  q,
  {
    icon: (e && Ct[e]) ?? E.FULL_CIRCLE,
    size: n,
    intent: e && bt[e],
    tooltipContent: s,
    className: m("sds_status-icon", i),
    popoverClassName: a
  }
) : null, Be = Object.fromEntries(
  Object.values(vt).map((e) => [e.type, e])
), Nt = (e) => r.object({
  conditions: r.tuple(
    (e ?? []).map(
      (s) => r.object({
        components: r.tuple(
          (s.components ?? []).map(
            (n) => r.object({
              value: H.getYupType({
                fieldType: n.type,
                isRequired: n.required,
                customComponents: Be,
                compProps: n
              })
            })
          )
        )
      })
    )
  )
}), kt = ({
  isOpen: e = !1,
  isCloseButtonShown: s = !1,
  subtaskObject: n = void 0,
  onSubmit: o,
  onCancel: i,
  enforceFocus: a = void 0,
  fileUploadConfig: _ = void 0,
  usePortal: u = !1
}) => {
  var X;
  const [v, C] = J([]), [g, T] = J([]);
  let M = !1;
  const R = (b) => {
    const l = structuredClone(b), { default: p, value: N, params: U, configuredParams: I } = l, D = ie(N), w = { ...l };
    if (w.value = D, w.value === void 0) {
      const W = p ?? (I == null ? void 0 : I.default) ?? (U == null ? void 0 : U.default);
      W !== void 0 && (w.value = W, M = !0);
    }
    return w;
  }, h = (b, l) => {
    const { params: p, configuredParams: N, ...U } = structuredClone(b);
    return {
      ...U,
      ...p,
      ...N,
      ...l ? { disabled: !0 } : {}
    };
  }, y = n == null ? void 0 : n.disableDialog, z = n ? structuredClone(n) : {}, P = n ? structuredClone(n) : void 0;
  (X = n == null ? void 0 : n.conditions) == null || X.forEach(
    (b, l) => {
      var p;
      return (p = b.components) == null ? void 0 : p.forEach((N, U) => {
        z.conditions[l].components[U] = R(N), P.conditions[l].components[U] = h(N, y);
      });
    }
  );
  const j = ee(P), G = (b) => {
    var l;
    return /* @__PURE__ */ d(A, { children: [
      /* @__PURE__ */ t(
        "div",
        {
          className: m(
            "padding__bottom--medium",
            "sds_performance-subtask-dialog__instructions"
          ),
          children: Y(
            `${(b == null ? void 0 : b.subtask_instructions) ?? "Instructions for subtask completion"}:`
          )
        }
      ),
      (l = b == null ? void 0 : b.conditions) == null ? void 0 : l.map((p, N) => {
        const U = `conditions.${N}`, {
          components: I,
          is_validated: D,
          use_component_validation: w
        } = p, W = D && !w;
        return /* @__PURE__ */ d(
          "div",
          {
            className: m(
              "sds_performance-subtask-dialog__condition",
              "padding__around--medium",
              {
                "margin__bottom--medium": b.conditions.length - 1 > N,
                "sds_performance-subtask-dialog__condition__border": D && p.status,
                [`sds_performance-subtask-dialog__condition__border--${p.status}`]: D && p.status
              }
            ),
            children: [
              /* @__PURE__ */ t(
                "div",
                {
                  className: m("sds_performance-subtask-dialog__input", {
                    "padding__right--medium": W
                  }),
                  children: I == null ? void 0 : I.map((ze, te) => {
                    const ve = `${U}.components.${te}.value`, x = h(
                      ze,
                      y
                    ), Ce = w && (x == null ? void 0 : x.is_validated);
                    return /* @__PURE__ */ d("div", { children: [
                      /* @__PURE__ */ d(
                        "div",
                        {
                          className: m({
                            "padding__bottom--medium": I.length - 1 > te,
                            "sds_performance-subtask-dialog__row": w,
                            "sds_performance-subtask-dialog__row--justify-with-space": w
                          }),
                          children: [
                            /* @__PURE__ */ t(
                              "div",
                              {
                                className: m(
                                  "sds_performance-subtask-dialog__input",
                                  {
                                    "padding__right--medium": Ce
                                  }
                                ),
                                children: /* @__PURE__ */ t(
                                  H,
                                  {
                                    component: x,
                                    id: ve,
                                    customComponents: Be,
                                    fileUploadConfig: {
                                      ..._,
                                      uploadPathId: p.condition_id ?? p.distinctId
                                    },
                                    setOnSubmitCallbacks: C,
                                    setOnCancelCallbacks: T
                                  }
                                )
                              }
                            ),
                            Ce && /* @__PURE__ */ t(
                              Me,
                              {
                                showEmptyCircle: !0,
                                status: x == null ? void 0 : x.status,
                                size: 20,
                                className: "sds_performance-subtask-dialog__status"
                              }
                            )
                          ]
                        }
                      ),
                      I.length - 1 > te && w && /* @__PURE__ */ t(We, { className: "sds_performance-subtask-dialog__condition__divider" })
                    ] }, ve);
                  })
                }
              ),
              W && /* @__PURE__ */ t(
                Me,
                {
                  showEmptyCircle: !0,
                  status: p == null ? void 0 : p.status,
                  size: 20,
                  className: "sds_performance-subtask-dialog__status"
                }
              )
            ]
          },
          U
        );
      })
    ] });
  };
  return j ? /* @__PURE__ */ t("div", { className: "sds_performance-subtask-dialog", children: /* @__PURE__ */ t(Ne, { initialValues: {}, onSubmit: () => {
  }, children: /* @__PURE__ */ t(
    Ye,
    {
      width: 750,
      isOpen: e,
      usePortal: u,
      enforceFocus: a,
      dialogTitle: (n == null ? void 0 : n.subtask_title) ?? "Subtask Name",
      onClose: i,
      dialogContent: G(P)
    }
  ) }) }) : /* @__PURE__ */ t(
    Ne,
    {
      onSubmit: async (b) => {
        await o(b), v.forEach((l) => l()), C([]);
      },
      initialValues: z,
      enableReinitialize: !0,
      validationSchema: P ? Nt(P.conditions) : void 0,
      validateOnMount: !0,
      children: (b) => /* @__PURE__ */ t("div", { className: "sds_performance-subtask-dialog", children: /* @__PURE__ */ t(
        He,
        {
          width: 750,
          isOpen: e,
          usePortal: u,
          enforceFocus: a,
          dialogTitle: b.values.subtask_title ?? "Subtask Name",
          isCloseButtonShown: s,
          onSecondaryButtonClick: (l) => {
            i(l), g.forEach((p) => p()), T([]);
          },
          secondaryButtonLabel: "Cancel",
          primaryButtonLabel: "Save",
          isPrimaryButtonDisabled: b.isSubmitting || !b.isValid || !(b.dirty || M),
          dialogContent: G(b.values),
          dataTestId: "performance-subtask-dialog"
        }
      ) })
    }
  );
};
export {
  tt as PerformanceItemStatusIcon,
  Xt as PerformanceManagementBase,
  kt as PerformanceSubtaskDialog,
  ot as isPerformanceValueCaseAutomatic,
  nt as isPerformanceValueCaseManual
};
//# sourceMappingURL=index.js.map
